import React, { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/store/store";
import {
  getDocuments,
  downloadDocument,
  deleteDocument,
  searchDocuments,
  getDocumentsPage,
  searchAdvanceDocuments,
} from "../../../redux/slices/DocumentsSlice";
import { fetchPullRepositorysById } from "../../../redux/slices/RepositorysSlice";
import { fetchDeletedDocumentRequest } from "../../../redux/slices/DeleteRequestDocumentSlice";
import Spinner from "../../Spinner/Spinner";
import "./TableDocuments.css";
import { Link } from "react-router-dom";
import { refreshToken2 } from '../../../refreshToken2';
import { useMsal } from '@azure/msal-react';
import Swal from "sweetalert2";
import { IRepositoryFilter } from "../../../types/RepositoryFilters";
import {
  replaceAt,
  cleanString,
  rejectEmptyKeysOrValues,
} from "../../../Helpers/Http.commons";
import { BASE_URL_ENDPOINT } from "../../../config/env";

const TableDocuments = () => {
  type LoadingRowState = {
    [key: number]: boolean;
  };

  interface Metadata {
    key: string;
    value: string;
  }

  interface Filter {
    option: string | null;
    value: string | null;
  }
  // console.log("BASE_URL_ENDPOINT:", BASE_URL_ENDPOINT);
  const [repositoryvalue, setRepositoryValue] = useState(false);
  const [page, setPage] = useState(1);
  const [formValid, setFormValid] = useState(false);
  const [take, setTake] = useState(10);
  const dispatch = useAppDispatch();
  const result = useAppSelector((state) => state.DocumentsSlice.result || []);
  const [documentId, setDocumentId] = useState<string | undefined>(undefined);
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingrow, setLoadingRow] = useState<LoadingRowState>({});
  const repositoryName = sessionStorage.getItem("repositoryName");
  const repositoriID = sessionStorage.getItem("repositoryId");
  const idUser: any = sessionStorage.getItem("userId");
  const idUserr: string = idUser.replace(/"/g, "");
  const [updateCount, setUpdateCount] = useState(0);
  const totalPages = ((sessionStorage.getItem('total-pages') != null) ? +sessionStorage.getItem('total-pages')! : 0);
  const { instance } = useMsal();
  // const ref = useRef(null);
  const [formObjec, setFormObjec] = useState({
    documentId: "",
    userId: idUserr,
  });
  const repositoryDataResponse: IRepositoryFilter = useAppSelector(
    (state) => state.RepositorysSlice.resultado
  ) || {
    id: "",
    name: "",
    description: "",
    businessUnitId: "",
    businessUnitName: "",
    businessUnitCostCenter: "",
    businessUnitResponsible: "",
    filters: [],
  };

  const [formObject, setFormObject] = React.useState({
    base64Document: "",
    path: "",
    fileName: "",
    description: "",
    createdAt: "",
    classification: "",
    accessFrequency: "",
    metadata: [
      {
        key: "",
        value: "",
      },
      {
        key: "",
        value: "",
      },
    ],
    repositoryName: "",
  });

  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [selectedFilters, setSelectedFilters] = useState<Array<object>>([]);
  const [searchFileName, setSearchFileName] = useState<string>("");
  const [medataDataAmountFields, setMedataDataAmountFields] =
    useState<number>(1);

  let queryString = window.location.search;
  let urlParams = new URLSearchParams(queryString);

  const handleUpdate = () => {
    setUpdateCount(updateCount + 1);
  };

  useEffect(() => {
    if (repositoryDataResponse && repositoryDataResponse.filters) {
      setSelectedOptions(repositoryDataResponse.filters);
    }
  }, [repositoryDataResponse]);

  console.log("repositoryDataResponse changed", repositoryDataResponse);
  console.log("result changed", result);

  useEffect(() => {
    setLoading(true);
    loadContent();
    setLoading(false);
  }, [repositoryName]);

  const loadContent = async () => {
    await refreshToken2(instance);
    await dispatch(getDocuments(({ Page: page, Take: take })));
    await dispatch(fetchPullRepositorysById(repositoriID ?? ""));
  };

  const GetDocumentByName = (name: any) => {
    setSearchFileName(name);
    setSelectedFilters([]);
    dispatch(searchDocuments(name));
  };

  const handleOnBlur = () => {
    if (!name) {
      dispatch(getDocuments(({ Page: page, Take: take })));
    }
  };

  const handleKeyDown = (e: any) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      GetDocumentByName(name);
    }
  };

  const DownloadandContinue = async (e: any, status: string) => {
    if(status ==="deleted"){
      return null;
    }
    try {
      e.preventDefault();
      const documentId = e.currentTarget.dataset.personId;
      if (!documentId) {
        console.log("Document ID not found");
        return;
      }
      const documentData = await dispatch(
        downloadDocument(documentId)
      ).unwrap();
      const downloadUrl = documentData.downloadUrl;
      const response = await fetch(downloadUrl, {
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": `https://docs-${repositoryName}-develop.s3.amazonaws.com`,
        },
      });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const fileName = downloadUrl.split("?")[0].split("/").reverse()[0];
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      // setLoadingRow({ ...loadingrow, [index]: false });
      window.focus();
    } catch (error) {
      console.error(error);
      // setLoadingRow({ ...loadingrow, [index]: false });
    }
  };

  const DeletedandContinue = async (e: any, id: any, uploadedBy: any, status:string) => {
    if(status ==="deleted"){
      return null;
    }
    const documentId = id;
    const idUser: any = sessionStorage.getItem("userId");
    const idUserr: string = idUser.replace(/"/g, "");
    setDocumentId(documentId);
    const data = { ...formObjec, documentId: documentId, userId: idUserr };
    setFormObjec(data);

    if (!data.documentId || !data.userId) {
      Swal.fire({
        icon: "warning",
        title: "oops!",
        text: "Aun no se cargaron los datos de la solicitud vuelve a intentarlo.",
      });
      return;
    }

    await new Promise((resolve) => setTimeout(resolve, 1000));

    if (idUserr === uploadedBy) {
      dispatch(deleteDocument(documentId)).then((response) => {
        if (deleteDocument.fulfilled.match(response)) {
          Swal.fire({
            icon: "success",
            title: "Exito!",
            text: "Se ha eliminado el documento con exito",
          });
          dispatch(getDocuments(({ Page: page, Take: take })));
        } else if (deleteDocument.rejected.match(response)) {
          // console.log('Request rejected:', response.error);
          const errorMessage = response.error.stack || "Something went wrong!";
          const regex = /{.*}/; // expresión regular para extraer el objeto JSON
          const match = regex.exec(errorMessage);
          const errorObject = match ? JSON.parse(match[0]) : {};
          const status = errorObject.status;
          const detail = errorObject.detail;
          Swal.fire({
            icon: "error",
            title: `(status: ${status})`,
            text: detail,
          });
          dispatch(getDocuments(({ Page: page, Take: take })));
        }
      });
    } else {
      dispatch(fetchDeletedDocumentRequest(data)).then((response) => {
        if (fetchDeletedDocumentRequest.fulfilled.match(response)) {
          Swal.fire({
            icon: "success",
            title: "Exito!",
            text: "No eres el dueño de este documento ,se ha generado una solicitud de eliminacion, y se ha enviado con exito",
          });
          dispatch(getDocuments(({ Page: page, Take: take })));
        } else if (fetchDeletedDocumentRequest.rejected.match(response)) {
          // console.log('Request rejected:', response.error);
          const errorMessage = response.error.stack || "Something went wrong!";
          const regex = /{.*}/; // expresión regular para extraer el objeto JSON
          const match = regex.exec(errorMessage);
          const errorObject = match ? JSON.parse(match[0]) : {};
          const status = errorObject.status;
          const detail = errorObject.detail;
          Swal.fire({
            icon: "error",
            title: `(status: ${status})`,
            text: detail,
          });
          dispatch(getDocuments(({ Page: page, Take: take })));
        }
      });
    }
  };

  const handlePageChange = (Page: number) => {
    // if(Page >0 && Page <= totalPages){
    if(Page >0 && Object.values(result).length > 0 ){
      setPage(Page);
      // console.log("Este es el Page:", Page);
      dispatch(getDocumentsPage({ Page: Page, Take: take, FileName: searchFileName, Filters: selectedFilters }));
      
    }
  };

  const handleTakeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    let page =1;
    setPage(page);
    event.preventDefault();
    const newTake = Number(event.target.value);
    setTake(newTake);
    // console.log("Este es el Take:", newTake);
    dispatch(getDocumentsPage({ Page: page, Take: newTake, FileName: searchFileName, Filters: selectedFilters }));
  };

  const handleSubmit = () => {
    let page =1;
    setPage(page);
    setSearchFileName("");
    dispatch(searchAdvanceDocuments(selectedFilters));
  };

  const cleanFilters = () => {
    let page =1;
    setPage(page);
    //TODO:
    // event.target.reset();
    setSelectedFilters([]);
    setSearchFileName("");
    dispatch(getDocuments(({ Page: page, Take: take })));
  };

  const handleSetFilter = (event: any, position: number) => {
    let currentFilter = selectedFilters[position];
    let currentValue = cleanString(event.target.value);

    if (event.target.type == "select-one") {
      currentFilter = { ...currentFilter, option: currentValue };
    } else {
      currentFilter = { ...currentFilter, value: currentValue };
    }

    const newFilters = replaceAt(selectedFilters, position, currentFilter);
    const cleanFilters = rejectEmptyKeysOrValues(newFilters);
    setSelectedFilters(cleanFilters);
  };

  const renderMetadataFilters = () => {
    if (!selectedOptions) return null;

    return (
      <div>
        <form>
        {Array.from(Array(medataDataAmountFields).keys()).map((position) => {
          return (
            <div className="row row-metadata">
              <div className="col-6">
                <select
                  id={`filter-select-${position}`}
                  name="select-input"
                  onChange={(e) => handleSetFilter(e, position)}
                  className="form-control"
                >
                  <option value="" hidden selected>
                    Selecciona una metadata
                  </option>
                  {Object.values(selectedOptions).map(
                    (repository: any, index) => (
                      <option key={`filter-option-${index}`} value={repository}>
                        {repository}
                      </option>
                    )
                  )}
                </select>
              </div>
              <div className="col-6">
                <input
                  id={`filter-input-${position}`}
                  aria-label="Input small"
                  type="text"
                  className=" form-control"
                  onChange={(e) => handleSetFilter(e, position)}
                />
              </div>
            </div>
          );
        })}
        </form>
        <div className="row">
          {/*<div className="col-6">
             <button
              className="pds-button pds-button-secondary Button-Search"
              onClick={() =>
                setMedataDataAmountFields(medataDataAmountFields + 1)
              }
            >
              Agregar
            </button> 
          </div>*/}
          <div className="col-6">
            <button
              className="pds-button pds-button-primary Button-Search"
              onClick={(e) => cleanFilters()}
            >
              Limpiar
            </button>
          </div>
          <div className="col-6">
            <button
              className="pds-button pds-button-primary Button-Search"
              onClick={() => handleSubmit()}
            >
              Buscar
            </button>
          </div>
        </div>
      </div>
    );
  };

  return loading ? (
    <Spinner />
  ) : (
    <div className="tableDocuments">
      <div className="pds-dataTable pds-dataTable-flexible">
        <div className="pds-dataTable-header title-documents">
          <p
            aria-hidden="true"
            className="pds-dataTable-title pds-typography-eyebrow-1"
          >
            Repositorio: {repositoryName}
          </p>
          <div>
            <Link to="/documents/uploadocument">
              <a href="#" className="pds-button pds-button-tertiary">
                <i data-feather="upload" data-size="20"></i> Subir Documentos
              </a>
            </Link>
          </div>
        </div>
        <div className="pds-collapsible">
          <details className="pds-collapsible-details">
            <summary
              className="pds-collapsible-summary"
              data-gtm="call-to-action-text"
            >
              Buscar
            </summary>
            <div className="pds-collapsible-details-text search-simple">
              <div className="div-input">
                <input
                  aria-label="Filter table data search bar"
                  className="search inputSearch pds-input-small input-search"
                  type="search"
                  onChange={(e) => setName(e.target.value)}
                  onKeyDown={handleKeyDown}
                  onBlur={handleOnBlur}
                  placeholder="Nombre de archivo"
                />
              </div>
              <div className="div-button-search">
                <button
                  type="submit"
                  onClick={() => GetDocumentByName(name)}
                  className="pds-button pds-button-primary button-search-simple"
                >
                  <i data-feather="magnifier" aria-hidden="true">
                    Busqueda
                  </i>
                </button>
              </div>
            </div>
          </details>
          <details className="pds-collapsible-details">
            <summary
              className="pds-collapsible-summary"
              data-gtm="call-to-action-text"
            >
              Busqueda por metadata
            </summary>
            <div className="pds-collapsible-details-text">
              {renderMetadataFilters()}
            </div>
          </details>
        </div>

        <div className="pds-dataTable-table-container pds-table-scrolling ">
          <table
            className="pds-table-container pds-table pds-table-bordered"
            id="pds-datatable-flexible-example"
            aria-live="polite"
          >
            <thead>
              <tr>
                <th
                  className="sort  title-header pds-typography-eyebrow-2"
                  scope="col"
                >
                  Directorio
                </th>
                <th
                  className="sort  title-header pds-typography-eyebrow-2"
                  scope="col"
                >
                  Nombre de Documento
                </th>

                <th
                  className="sort  title-header pds-typography-eyebrow-2"
                  scope="col"
                >
                  Fecha de Creacion
                </th>
                <th
                  className="sort  title-header pds-typography-eyebrow-2"
                  scope="col"
                >
                  Estado
                </th>
                <th
                  className=" my-table-id sort  title-header pds-typography-eyebrow-2"
                  scope="col"
                  colSpan={2}
                >
                  Accion
                </th>
              </tr>
            </thead>
            {Object.values(result).length > 0 &&
              Object.values(result).map((person, index) => (
                <tbody>
                  <tr key={index}>
                    <td className="pds-dataTable-table-item">{person.path}</td>
                    <td className="pds-dataTable-table-item">
                      {person.fileName}
                    </td>
                    <td className="pds-dataTable-table-item">
                      {person.createdAt.toString().slice(0, -14)}
                    </td>
                    <td className="pds-dataTable-table-item">
                      {person.status}
                    </td>
                    <td className="pds-dataTable-table-item data-item-action">
                      <button
                        className="pds-button pds-button-tertiary button-download"
                        data-person-id={person.id}
                        disabled={person.status ==="deleted"}
                        onClick={(e) => DownloadandContinue(e, person.status)}
                      >
                        <i data-feather="download" data-size="20"></i>
                      </button>
                    </td>
                    
                    <td className="pds-dataTable-table-item data-item-action">
                      <button
                        className="pds-button pds-button-tertiary button-deleted"
                        data-uploadedby={person.uploadedBy}
                        data-person-id={person.id}
                        disabled={person.status ==="deleted"}
                        onClick={(e) =>
                          DeletedandContinue(e, person.id, person.uploadedBy, person.status)
                        }
                      >
                        <i data-feather="trash-2" data-size="20"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              ))}
          </table>
        </div>
        <div className="pds-dataTable-footer">
          <div className="pds-dataTable-show-entries">
            <label className="pds-dataTable-select-label" />
            <div className="pds-select">
            <select
                    id=""
                    aria-label="Number of rows to display in table" name="entries" className="pds-dataTable-select-options pds-select-small"
                    value={take}
                    onChange={handleTakeChange}>
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                    <option value={20}>20</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                  </select>
            </div>
            Page: {page}
          </div>
          <nav
                aria-label="Pagination"
                className="pds-pagination pds-dataTable-pagination"
              >
                <span className="pds-dataTable-previous-buttons pds-dataTable-disable-pagination-buttons">
                  {/* <a
                    role="link"
                    tabIndex={0}
                    aria-label="first page"
                    aria-disabled={page === 1}
                    className={`pds-dataTable-first-page pds-pagination-fly-first page pds-pagination-link ${page === 1 ? 'disabled' : ''
                      }`}
                    onClick={() => handlePageChange(1)}
                  /> */}
                  <a
                    role="link"
                    tabIndex={0}
                    aria-label="Previous page"
                    aria-disabled={page === 1}
                    className={`pds-dataTable-previous pds-pagination-step-forward page pds-pagination-link ${page === 1 ? 'disabled' : '' }`}
                    onClick={() => handlePageChange(page - 1)} />
                </span>
                <span className="pds-dataTable-next-buttons">
                  <a
                    role="link"
                    tabIndex={0}
                    aria-label="Next page"
                    className={`pds-dataTable-next pds-pagination-step-backward page pds-pagination-link ${Object.values(result).length <= 0 ? 'disabled' : '' }`}
                    onClick={() => handlePageChange(page + 1)}
                  />
                  {/* <a
                    role="link"
                    tabIndex={0}
                    aria-label="Last page"
                    className={`pds-dataTable-last-page pds-pagination-fly-last page pds-pagination-link ${page === totalPages ? 'disabled' : '' }`}
                    onClick={() => handlePageChange(totalPages)}
                  /> */}
            </span>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default TableDocuments;
